/**
 * Error type thrown by the service layer. Screens narrow on `instanceof
 * ApiError` to show the server's message and fall back to a generic message
 * for anything else (network failures, parse errors).
 */
export class ApiError extends Error {
  status: number;
  /** The parsed error body, when the server sent one. Screens use `message`;
   *  this is for the rare caller that needs a field-level error map. */
  data?: unknown;

  constructor(message: string, status = 0, data?: unknown) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}
